import { DeclarationStatus } from 'evee-ui-common/enums';

export default {
  declaration: {
    status: DeclarationStatus.unverified,
    verifiedTill: null,
    questionnaire: [],
    failedQuestions: [],
    accepted: false, // todo: remove
  },
};
